export const wipConfig = {
  commonConfig: {
    derived: '',
    apiKey: 'afb5939e20276ad77dcaff1f77e4a8677aafa988',
    appEnv: 'dev',
    crossAdvertiserID: 999999994,
    keywordOfflineExportLimit: 60,
    keywordOfflineExportLimitIncreased: 100,
    supportURL: 'https://xyc.partnersonline.com/page/help/MzQ3',
    supportURLs: {
      RMS: {
        help: '/categories/Performance/Reports',
        ticket: '/contact?productType=Kiosk',
        termsOfUseLink: '/terms',
      },
      POL: {
        termsOfUseLink: 'sites/ogrp-tts-polapplications/Pages/3649.aspx',
      },
      targetPlus: {
        termsOfUseLink: '',
      },
    },
    firefly_url:
      'https://stage-api.target.com/consumers/v1/ingest/internal/internal_app',
    termsOfUseLink: 'sites/ogrp-tts-polapplications/Pages/3649.aspx',
    UI_CACHE_TIME: 300000,
    metricsAdminGroup: 'APP-RIK-METRICS-ADMIN-STAGE',
    templateAdminGroup: 'APP-RIK-TEMPLATE-ADMIN-STAGE',
    rikAdminSettingsGroup: 'APP-RIK-UI-DEV-ADMIN',
    tpaCadenceAdminADGroup: 'APP-RIK-TPA-CADENCE-ADMN-STG',
    rikLimitedAccessGroup: 'APP-RIK-LIMITED-USER-STAGE',
    targetPlusManagedService: 'APP-SMS',
    rpiURL: 'https://rpiui-wip.dev.target.com/',
    rmsAccessGroups:
      'APP-OAUTH2-RMS-Prod-Read, APP-OAUTH2-RMS-Prod-Admin, APP-OAUTH2-RMS-Prod-Update, APP-OAUTH2-RMS-Prod-Update, APP-OAUTH2-RMS-Read-Prod',
    rmsEnterpriseURL: 'https://roundelmediastudio.perf.target.com',
    rmsPolURL: 'https://roundelmediastudio.perf.partnersonline.com',
    roundelHelpCenterEnterpriseURL: 'https://roundelhelpcenter.perf.target.com',
    roundelPlanningEnterpriseURL: 'https://rmsplanning.dev.target.com',
    roundelPlanningPolURL: 'https://roundelmediastudio.perf.partnersonline.com',
    roundelHelpCenterPolURL:
      'https://roundelhelpcenter.perf.partnersonline.com',
    auth: {
      clientId: 'rik_npe_im',
      authorizationUrl:
        'https://oauth.iam.perf.partnersonline.com/auth/oauth/v2/tgt/authorize/nla/1',
      logoutUrl:
        'https://oauth.iam.perf.partnersonline.com/login/responses/logoff.html',
    },
    fireflyConfig: {
      appName: 'ROUNDEL_KIOSK_UI',
      apiKey: '7b74f296e995308aca35d78b17ebde4975530029',
      retries: 1,
      url: 'https://stage-api.target.com/firefly_internal_events/v1/external',
    },
    otelConfig: {
      // Target OpenTelemetry (TAP) configuration.
      // NOTE: per TAP docs this must be a PRODUCTION API key even for non-prod
      // deployments. Replace the value below with your generated key.
      apiKey: '6c99d53c7ab958d58ce033477e23cb3374aa18d5',
      serviceName: 'rik',
    },
    authInternal: {
      clientId: 'rik_npe_im',
      authorizationUrl:
        'https://oauth.iam.perf.target.com/auth/oauth/v2/tgt/authorize/ad-pol/1',
      logoutUrl:
        'https://logonservices.iam.perf.target.com/login/responses/logoff.html',
    },
    crossAdvertiser: {
      offlineExportRecordLimit: 1500000,
      carId: 999999994,
    },
    educationAlerts: {
      version: 'v1',
      message: {
        internalMsg:
          "<strong>Introducing the 'Mapping Info' sidebar tab in Kiosk! </strong><br> This new tab, available to all internal users, can be used to understand how accounts are mapped (or not mapped) in Kiosk. The 'Vendor Mapping' table, for example, can be used for determining whether or not an account is already mapped for access in Kiosk or for troubleshooting account naming nuances!",
        msMsg:
          "<strong>Refreshed Training Documentation Available! </strong><br> Roundel Kiosk recently updated the training documentation within Partners Online (POL) and can be viewed by clicking on the Help Icon in the upper right corner of the screen. Whether you're new to the tool or need a quick refresher, our step-by-step guides and tips are here to support you. Explore the updated materials today to enhance your campaign reporting experience! ",
        rmsMsg:
          "<strong><i>NEW Feature</i> - Instantly view reports for <i>any</i> campaign, Live or Completed - right from the dashboard - that too in a <i>single</i> click!</strong><p>By default, these single click reports are generated for your campaign of choice using one of our recommended 'Roundel Global Templates' but you could use the 'Customize' button in the section below to select a preferred template of your choice. Preferred templates can be at an individual Campaign level or even at a Campaign Category level! <br />Try it out for your self by clicking on any campaign name below!</p>",
      },
      maxCount: 10,
    },
    educationAlerts2: {
      version: 'v2',
      message: `<strong>New! Enhanced Benchmarks for Precision Plus by Roundel Campaigns</strong><br> Benchmarks in Roundel Kiosk now factor in your campaign’s marketing objective (Awareness, Consideration, or Conversion) ensuring comparisons are made against campaigns with similar goals. This added layer helps you better contextualize and understand performance across campaigns optimized toward the same outcomes. To learn more about Roundel Kiosk's benchmarks and how to view them for qualifying campaigns, visit the Roundel Support Center's "Benchmarks" article under Roundel Kiosk: <strong><a style="text-decoration:underline" target="_blank" href="https://roundelhelpcenter.perf.target.com/categories/Performance/Reports/Build_reports/article/000206943">Understanding Benchmarks in Roundel Kiosk </a></strong>`,
      maxCount: 10,
    },
    largeExportLimits: {
      subtypeRowCountInternalUsers: {
        SEARCH_KEYWORD_LEVEL: 300,
        SEARCH_ACTIVITY: 300,
        CAMPAIGN_DAY_LEVEL: 500,
        ITEM_SALES: 400,
        CAMPAIGN_ITEM_LEVEL: 700,
        CAMPAIGN_TOTAL_LEVEL: 3000,
        MEDIA_BENCHMARKS: 1500,
        CAMPAIGN_REPORT_LEVEL: 700,
        LIVE_CAMPAIGN_HEALTH_CHECK: 700,
        PLACEMENT_LEVEL: 700,
      },
      subtypeRowCountCrossAdvertisers: {
        SEARCH_KEYWORD_LEVEL: 300,
        SEARCH_ACTIVITY: 300,
        CAMPAIGN_DAY_LEVEL: 2000,
        ITEM_SALES: 400,
        CAMPAIGN_ITEM_LEVEL: 700,
        CAMPAIGN_TOTAL_LEVEL: 3000,
        MEDIA_BENCHMARKS: 1500,
        CAMPAIGN_REPORT_LEVEL: 700,
        LIVE_CAMPAIGN_HEALTH_CHECK: 700,
        PLACEMENT_LEVEL: 700,
      },
      email: 300,
    },
  },
  internalUserConfig: {
    atl: {
      host: 'https://rikrmsatl-wip.dev.target.com/roundel_rik_campaigns_attributed_transaction_log_data/',
      paths: {
        aggregation: 'v1/atl_data',
        aggregateStatuses: 'v1/atl_data_status',
      },
    },
    campaign: {
      host: 'https://rikcampaignapi-wip.dev.target.com/roundel_rik_campaigns/',
      paths: {
        aggregateStatuses: 'v1/aggregate_statuses',
        overview: 'v1/overviews',
        overviewV2: 'v2/overviews',
        aggregation: 'v2/aggregate',
        search: 'v1/search',
        searchV2: 'v2/search',
        load: 'v2/cache_loads',
        metaData: 'v2/metadata/MEDIA_NAME',
        dimensionsMetaData: 'v2/metadata',
        notifications: 'v1/notices',
        userInfo: 'v1/user_info',
        crossAdvertiserSearch: 'v2/cross_advertiser_search',
        preAggregateRowCount: 'v1/pre_aggregate_row_counts',
        vendorAccountBrandMapping: 'v2/vendor_account_brand_mappings',
      },
    },
    campaignTemplate: {
      host: 'https://rikviewapi-wip.dev.target.com/roundel_rik_template_mappings/v1',
      paths: {
        campaignTemplate: '/template_mappings',
        globalTemplateMap: '/vendor_template_mappings',
      },
    },
    cloudStorage: {
      host: 'https://rikcloudstorageapi-wip.dev.target.com/roundel_rik_cloud_storage_data/v1',
      paths: {
        bucketDetails: '/bucket_details',
        awsRegion: '/aws_regions',
      },
    },
    customMetrics: {
      host: 'https://rikviewapi-wip.dev.target.com/roundel_rik_custom_metrics/v1',
      paths: {
        metrics: '/metrics',
      },
    },
    export: {
      host: 'https://rikviewexportservice-wip.dev.target.com/roundel_rik_campaigns_data/v1',
      paths: {
        directExport: '/exports',
        dashboardExport: '/dashboard_exports',
        exportStatus: '/export_statuses',
      },
    },
    feedback: {
      host: 'https://rikfeedbackapi-wip.dev.target.com/roundel_rik_feedbacks/v1',
      paths: {
        feedback: '/',
        feedbackSurveyInfo: '/feedback_survey_info',
        feedbackSurveyResponse: '/feedback_survey_user_response',
      },
    },
    feedbackAPI: {
      host: 'https://rikfeedbackapi-wip.dev.target.com/roundel_rik_email_preferences/v1',
      paths: {
        emailAlertTracking: '/email_alerts',
        notificationPreference: '',
      },
    },
    itemPerformance: {
      host: 'https://rikitemperformanceapi-wip.dev.target.com/roundel_rik_campaigns_item_performance_data/',
      paths: {
        aggregation: 'v1/aggregate',
        load: 'v1/cache_loads',
        tcinMetaData: 'v2/tcin_metadata',
        metaData: 'v2/metadata/MEDIA_NAME',
        aggregateStatuses: 'v1/aggregate_statuses',
      },
    },
    metrics: {
      host: 'https://rikviewapi-wip.dev.target.com/roundel_rik_metrics/v1',
      paths: {
        metrics: '/metrics',
      },
    },
    modelEnablement: {
      host: 'https://modelenablementapi-wip.dev.target.com/roundel_rik_campaign_model_enablement_data/v1',
      paths: {
        aggregation: '/aggregate',
        load: '/cache_loads',
      },
    },
    modelEnablementExport: {
      host: 'https://exportmodelenablement-wip.dev.target.com/roundel_rik_campaign_model_enablement_data_exports',
      paths: {
        cloudExport: '/v1/exports',
        tossExport: '/v1/toss_export_requests',
        tossDownload: '/v1/toss_download',
      },
    },
    scheduleReports: {
      host: 'https://rikschedulingapi-wip.dev.target.com/roundel_rik_schedules/v1',
      paths: {
        scheduleReports: '/report_schedules',
      },
    },
    whatsNewTour: {
      host: 'https://rikfeedbackapi-wip.dev.target.com/roundel_rik_feedbacks/v1',
      paths: {
        getWhatsNewTour: '/whatsnew_popover_info',
        updateWhatsNewTour: '/update_whatsnew_popover',
      },
    },
    globalWhatsNew: {
      host: 'https://rikfeedbackapi-wip.dev.target.com/roundel_rik_feedbacks/v1',
      paths: {
        getGlobalWhatsNew: '/get_global_whatsnew',
        updateGlobalWhatsNew: '/update_global_whatsnew',
      },
    },
    sharepoint: {
      host: 'https://rikadminapi-wip.dev.target.com/roundel_rik_admins/v1',
      paths: {
        sharepoint: '/admin_configs',
      },
    },
    unleash: {
      host: 'https://rikadminapi-wip.dev.target.com/roundel_rik_admins/v1',
      paths: {
        featureFlag: '/feature_flag',
      },
    },
    targetPlusSupportURL: {
      paths: '',
    },
    userMappings: {
      host: 'https://vendorsmapping-wip.dev.target.com/rik_users/v1',
      paths: {
        userMappings: '/users',
        updateUserMapping: '/user_vendor_mappings',
        criteoAccounts: '/rms_accounts',
      },
    },
    vendorMappings: {
      host: 'https://vendorsmapping-wip.dev.target.com/roundel_rik_vendor_mappings/v1',
      paths: {
        vendors: '',
        vendorMappings: '',
        updateVendorMapping: '',
        salesforceAccounts: '/salesforce_accounts',
      },
    },
    tpaCadence: {
      host: 'https://vendorsmapping-wip.dev.target.com/rik_tpa_cadence_email_preferences/v1',
      paths: {
        tpaCadence: '',
        addTpaCadence: '/bulk',
      },
    },
    viewAPI: {
      host: 'https://rikviewapi-wip.dev.target.com/roundel_rik_views/v1',
      paths: {
        dimensions: '/dimensions',
        columns: '/lovs/columns',
        templates: '/templates',
        templateName: '/templates/template_name',
        checkDuplicate: '/templates/duplicate/template_name',
        views: '/views',
        pinnedView: '/pinned_views',
        defaultReports: '/default_reports',
        crossAdvertiserUserPreferences: '/cross_advertiser_user_preferences',
      },
    },
  },
  externalUserConfig: {
    atl: {
      host: 'https://rikrmsatl-wip.dev.target.com/roundel_rik_campaigns_attributed_transaction_log_data/',
      paths: {
        aggregation: 'v1/atl_data',
        aggregateStatuses: 'v1/atl_data_status',
      },
    },
    campaign: {
      host: 'https://rikcampaignapi-wip.dev.target.com/roundel_rik_campaigns/',
      paths: {
        aggregateStatuses: 'v1/aggregate_statuses',
        overview: 'v1/overviews',
        overviewV2: 'v2/overviews',
        aggregation: 'v2/aggregate',
        search: 'v1/search',
        searchV2: 'v2/search',
        load: 'v2/cache_loads',
        metaData: 'v2/metadata/MEDIA_NAME',
        dimensionsMetaData: 'v2/metadata',
        notifications: 'v1/notices',
        userInfo: 'v1/user_info',
        preAggregateRowCount: 'v1/pre_aggregate_row_counts',
      },
    },
    campaignTemplate: {
      host: 'https://rikviewapi-wip.dev.target.com/roundel_rik_template_mappings/v1',
      paths: {
        campaignTemplate: '/template_mappings',
        globalTemplateMap: '/vendor_template_mappings',
      },
    },
    cloudStorage: {
      host: 'https://rikcloudstorageapi-wip.dev.target.com/roundel_rik_cloud_storage_data/v1',
      paths: {
        bucketDetails: '/bucket_details',
        awsRegion: '/aws_regions',
      },
    },
    export: {
      host: 'https://rikviewexportservice-wip.dev.target.com/roundel_rik_campaigns_data/v1',
      paths: {
        directExport: '/exports',
        dashboardExport: '/dashboard_exports',
        exportStatus: '/export_statuses',
      },
    },
    feedback: {
      host: 'https://rikfeedbackapi-wip.dev.target.com/roundel_rik_feedbacks/v1',
      paths: {
        feedback: '/',
        feedbackSurveyInfo: '/feedback_survey_info',
        feedbackSurveyResponse: '/feedback_survey_user_response',
      },
    },
    feedbackAPI: {
      host: 'https://rikfeedbackapi-wip.dev.target.com/roundel_rik_email_preferences/v1',
      paths: {
        emailAlertTracking: '/email_alerts',
        notificationPreference: '',
      },
    },
    itemPerformance: {
      host: 'https://rikitemperformanceapi-wip.dev.target.com/roundel_rik_campaigns_item_performance_data/',
      paths: {
        aggregation: 'v1/aggregate',
        load: 'v1/cache_loads',
        tcinMetaData: 'v2/tcin_metadata',
        metaData: 'v2/metadata/MEDIA_NAME',
        aggregateStatuses: 'v1/aggregate_statuses',
      },
    },
    metrics: {
      host: 'https://rikviewapi-wip.dev.target.com/roundel_rik_metrics/v1',
      paths: {
        metrics: '/metrics',
      },
    },
    modelEnablement: {
      host: 'https://modelenablementapi-wip.dev.target.com/roundel_rik_campaign_model_enablement_data/v1',
      paths: {
        aggregation: '/aggregate',
        load: '/cache_loads',
      },
    },
    modelEnablementExport: {
      host: 'https://exportmodelenablement-wip.dev.target.com/roundel_rik_campaign_model_enablement_data_exports',
      paths: {
        cloudExport: '/v1/exports',
        tossExport: '/v1/toss_export_requests',
        tossDownload: '/v1/toss_download',
      },
    },
    scheduleReports: {
      host: 'https://rikschedulingapi-wip.dev.target.com/roundel_rik_schedules/v1',
      paths: {
        scheduleReports: '/report_schedules',
      },
    },
    whatsNewTour: {
      host: 'https://rikfeedbackapi-wip.dev.target.com/roundel_rik_feedbacks/v1',
      paths: {
        getWhatsNewTour: '/whatsnew_popover_info',
        updateWhatsNewTour: '/update_whatsnew_popover',
      },
    },
    globalWhatsNew: {
      host: 'https://rikfeedbackapi-wip.dev.target.com/roundel_rik_feedbacks/v1',
      paths: {
        getGlobalWhatsNew: '/get_global_whatsnew',
        updateGlobalWhatsNew: '/update_global_whatsnew',
      },
    },
    sharepoint: {
      host: 'https://rikadminapi-wip.dev.target.com/roundel_rik_admins/v1',
      paths: {
        sharepoint: '/admin_configs',
      },
    },
    unleash: {
      host: 'https://rikadminapi-wip.dev.target.com/roundel_rik_admins/v1',
      paths: {
        featureFlag: '/feature_flag',
      },
    },
    targetPlusSupportURL: {
      paths: '',
    },
    viewAPI: {
      host: 'https://rikviewapi-wip.dev.target.com/roundel_rik_views/v1',
      paths: {
        dimensions: '/dimensions',
        columns: '/lovs/columns',
        templates: '/templates',
        templateName: '/templates/template_name',
        checkDuplicate: '/templates/duplicate/template_name',
        views: '/views',
        pinnedView: '/pinned_views',
        defaultReports: '/default_reports',
      },
    },
  },
}
